import clsxm from '@/lib/clsxm';

import {
  ArrowGlyph,
  CheckGlyph,
  SectionHeading,
  tone,
} from '@/components/agents/primitives';

import { REWARDFUL } from './kit';

const WELCOME = [
  'Your website or blog',
  'Your social media following',
  'Content you create about Easy-Peasy.AI',
  'Your network and your clients',
];

// From the Affiliate Terms and Conditions on Rewardful.
const NOT_ALLOWED = [
  'Signing up through your own link',
  'Coupon, cashback or bargain sites, and made-up discounts',
  'Search ads on our brand names: add “Easy-Peasy.AI” and “Easy Peasy AI” as negative keywords',
  'Facebook ads that link to our website',
  'Presenting yourself as part of our team',
  'Bot traffic or bought email lists',
];

function CrossGlyph({ className }: { className?: string }) {
  return (
    <svg viewBox='0 0 20 20' className={className} aria-hidden='true'>
      <path
        d='M6 6l8 8M14 6l-8 8'
        stroke='currentColor'
        strokeWidth='1.8'
        strokeLinecap='round'
        fill='none'
      />
    </svg>
  );
}

export default function AffiliatesRules() {
  return (
    <section className='pb-24 sm:pb-32'>
      <div className='mx-auto max-w-7xl px-6 lg:px-8'>
        <SectionHeading
          title='Play fair.'
          tail='The short version of the terms.'
          lead='Commissions are paid on real customers you bring in. Sales that break these rules aren’t paid, and the account can be closed.'
        />

        <div className='mt-14 grid gap-4 md:grid-cols-2'>
          <div
            className={clsxm(
              'rounded-[22px] p-7 sm:p-8',
              tone.surface,
              tone.line,
            )}
          >
            <h3 className={clsxm('text-lg font-semibold', tone.ink)}>
              Share it anywhere you have an audience
            </h3>
            <ul className='mt-5 space-y-3.5'>
              {WELCOME.map((item) => (
                <li
                  key={item}
                  className={clsxm(
                    'flex gap-2.5 text-[15px] leading-6',
                    tone.body,
                  )}
                >
                  <CheckGlyph className='mt-0.5 h-[18px] w-[18px] flex-none' />
                  {item}
                </li>
              ))}
            </ul>
          </div>

          <div
            className={clsxm(
              'rounded-[22px] p-7 sm:p-8',
              tone.surface,
              tone.line,
            )}
          >
            <h3 className={clsxm('text-lg font-semibold', tone.ink)}>
              Not allowed
            </h3>
            <ul className='mt-5 space-y-3.5'>
              {NOT_ALLOWED.map((item) => (
                <li
                  key={item}
                  className={clsxm(
                    'flex gap-2.5 text-[15px] leading-6',
                    tone.body,
                  )}
                >
                  <CrossGlyph className='mt-0.5 h-[18px] w-[18px] flex-none text-rose-500' />
                  {item}
                </li>
              ))}
            </ul>
          </div>
        </div>

        <a
          href={REWARDFUL.terms}
          target='_blank'
          rel='noopener noreferrer'
          className={clsxm(
            'mt-8 inline-flex items-center gap-1.5 text-[15px] font-semibold underline-offset-4 hover:underline',
            tone.ink,
          )}
        >
          Read the full affiliate terms
          <ArrowGlyph className='h-3.5 w-3.5 -rotate-45' />
        </a>
      </div>
    </section>
  );
}
